import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import useApi from '@/hooks/useApi';
import IcCheck from '@/assets/icons/Check.svg?react';
import Row from './Row';
import SkeletonRow from './SkeletonRow';
import styles from './NeedsAttention.module.scss';

const SKELETON_ROW_COUNT = 3;

const NeedsAttention = () => {
  const { t } = useTranslation(['common']);
  const [load, { response, loading }] = useApi('dashboard.needsAttention');

  useEffect(() => {
    void load();
  }, [load]);

  const items = response?.data ?? [];
  const isLoading = loading === true && !response;
  const isEmpty = !isLoading && items.length === 0;

  return (
    <section className={styles.section}>
      <header className={styles.header}>
        <h2 className={styles.heading}>
          {t('common:dashboard.needsAttention.title')}
        </h2>
        {!isLoading && !isEmpty && (
          <div className={styles.summary}>
            {t('common:dashboard.needsAttention.summary', {
              count: items.length,
            })}
          </div>
        )}
      </header>
      {isEmpty ? (
        <div className={styles.emptyCard}>
          <span className={styles.emptyIcon} aria-hidden="true">
            <IcCheck />
          </span>
          <div className={styles.emptyMeta}>
            <div className={styles.emptyTitle}>
              {t('common:dashboard.needsAttention.emptyTitle')}
            </div>
            <div className={styles.emptySubtitle}>
              {t('common:dashboard.needsAttention.emptySubtitle')}
            </div>
          </div>
        </div>
      ) : (
        <ul className={styles.list}>
          {isLoading
            ? Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
                <SkeletonRow key={index} />
              ))
            : items.map((item) => (
                <Row key={item.signing.id + item.type} item={item} t={t} />
              ))}
        </ul>
      )}
    </section>
  );
};

export default NeedsAttention;
